import {useState, useEffect, useRef} from 'react';
// import {CircularLinkedList} from './linked-list';

interface UseCircularScrollOptions {
  data: any[];
  visibleCount?: number;
  duration?: number;
  delay?: number;
  itemHeight?: number;
}

interface ScrollItem<T> {
  data: T;
  translateY: number;
}

export const useCircularScroll = ({
  data,
  duration = 500,
  delay = 3000,
  itemHeight = 50,
}: //   visibleCount = 3,
UseCircularScrollOptions) => {
  const [items, setItems] = useState<ScrollItem<any>[]>([]);
  const animationRef = useRef<NodeJS.Timeout>();
  const MIN_ITEMS_FOR_ANIMATION = 3; // 定义最小动画所需数据条数

  // 初始化数据，第一个位置为0，后续依次累加
  useEffect(() => {
    if (data.length > 0) {
      const initialItems = data.map((item, index) => ({
        data: item,
        translateY: index * itemHeight,
      }));
      setItems(initialItems);
    }
  }, [data, itemHeight]);

  useEffect(() => {
    // 只有当数据超过3条时才启动动画
    if (items.length > MIN_ITEMS_FOR_ANIMATION) {
      const animate = () => {
        setItems(currentItems => {
          const newPositions = currentItems.map(item => ({
            ...item,
            translateY: item.translateY - itemHeight,
          }));

          const itemsToMove = newPositions.filter(item => item.translateY < 0);
          const remainingItems = newPositions.filter(
            item => item.translateY >= 0,
          );

          const reorderedItems = [
            ...remainingItems,
            ...itemsToMove.map(item => ({
              ...item,
              translateY: (items.length - 1) * itemHeight,
            })),
          ];

          return reorderedItems;
        });

        animationRef.current = setTimeout(animate, delay);
      };

      animationRef.current = setTimeout(animate, delay);
    }

    return () => {
      if (animationRef.current) {
        clearTimeout(animationRef.current);
      }
    };
  }, [items.length, delay, itemHeight]);

  return {
    visibleItems: items,
    duration,
    shouldAnimate: items.length > MIN_ITEMS_FOR_ANIMATION, // 添加标志位表示是否需要动画
  };
};
